import * as React from 'react';
import { useSettingsContext } from '../contexts/settings';
import { IPost } from '../types';
import Default from './cards/Default';
import Learn from './cards/Learn';
import BeforeAfter from './cards/BeforeAfter';
import Doctor from './cards/Doctor';

interface IProps {
	posts: Array<IPost>;
	setLoadingHeight?: (height: number | null) => void;
}

const PostsGrid = ({ posts, setLoadingHeight }: IProps) => {
	const tableRef = React.useRef<HTMLDivElement | null>(null);
	const settings = useSettingsContext();

	React.useEffect(() => {
		if (setLoadingHeight) {
			if (null !== tableRef.current && tableRef.current.offsetHeight) {
				setLoadingHeight(tableRef.current.offsetHeight);
			} else {
				setLoadingHeight(null);
			}
		}
	}, [posts]);

	if (posts.length) {
		return (
			<div ref={tableRef} className={`pfa-posts-grid pfa-posts-grid--${settings.postType}`}>
				{posts.map((post) => {
					switch (post.post_type) {
						// You can use this to add different cards.
						case 'learn': {
							return <Learn post={post} key={post.ID} />;
						}
						case 'before_after': {
							return <BeforeAfter post={post} key={post.ID} />;
						}
						case 'doctor': {
							return <Doctor post={post} key={post.ID} />;
						}
						default: {
							return <Default post={post} key={post.ID} />;
						}
					}
				})}
			</div>
		);
	}

	return <></>;
};

PostsGrid.displayName = 'PostsGrid';

export default PostsGrid;
